import { Sort } from '@spike/model';
import { faMoon } from '@fortawesome/free-solid-svg-icons/faMoon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TableHeader } from 'components/UI/V3/Table/Header/TableHeader';
import { FunctionComponent } from 'react';
import HeaderTableColumn from './HeaderTableColumn';
import styles from './RequestedHeaderTable.module.scss';
import { appointmentSortColumns } from './groomingSort';
import { getServiceCategoryByTabId } from './tabs';

interface RequestedHeaderTableProps {
    selectedTabId: string;
    sort: Sort | null;
    onSort?: (sort: Sort) => void;
}

export const RequestedHeaderTable: FunctionComponent<RequestedHeaderTableProps> = props => {
    const serviceCategory = getServiceCategoryByTabId(props.selectedTabId);

    return (
        <TableHeader>
            <HeaderTableColumn
                sortColumn={appointmentSortColumns.client}
                selectedSort={props.sort}
                onServerSort={props.onSort}
            >
                Client Name
            </HeaderTableColumn>
            <HeaderTableColumn
                sortColumn={appointmentSortColumns.pet}
                selectedSort={props.sort}
                onServerSort={props.onSort}
            >
                Pet Name
            </HeaderTableColumn>
            <HeaderTableColumn
                sortColumn={appointmentSortColumns.service}
                selectedSort={props.sort}
                onServerSort={props.onSort}
            >
                Service
            </HeaderTableColumn>
            {serviceCategory === 'grooming' && (
                <HeaderTableColumn
                    sortColumn={appointmentSortColumns.staff}
                    selectedSort={props.sort}
                    onServerSort={props.onSort}
                >
                    Staff
                </HeaderTableColumn>
            )}
            {serviceCategory === 'boarding' ? (
                <>
                    <HeaderTableColumn
                        sortColumn={appointmentSortColumns.checkIn}
                        selectedSort={props.sort}
                        onServerSort={props.onSort}
                    >
                        Check In
                    </HeaderTableColumn>
                    <HeaderTableColumn
                        sortColumn={appointmentSortColumns.checkOut}
                        selectedSort={props.sort}
                        onServerSort={props.onSort}
                    >
                        Check Out
                    </HeaderTableColumn>
                    <HeaderTableColumn
                        sortColumn={appointmentSortColumns.nights}
                        selectedSort={props.sort}
                        onServerSort={props.onSort}
                        className={styles.nights}
                    >
                        <FontAwesomeIcon icon={faMoon} />
                    </HeaderTableColumn>
                </>
            ) : (
                <HeaderTableColumn
                    sortColumn={appointmentSortColumns.bookedAt}
                    selectedSort={props.sort}
                    onServerSort={props.onSort}
                >
                    Date & Time
                </HeaderTableColumn>
            )}
            <HeaderTableColumn
                sortColumn={appointmentSortColumns.total}
                selectedSort={props.sort}
                onServerSort={props.onSort}
            >
                Total
            </HeaderTableColumn>
        </TableHeader>
    );
};

export default RequestedHeaderTable;
